export default import.meta.ROLLDOWN_FILE_URL__8eNqn6QUYmeKWLG9tKB8A